import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { NoxoButton } from '@noxo/ui/button';

@Component({
  selector: 'lib-cookie-consent-banner',
  imports: [NoxoButton],
  templateUrl: './cookie-consent-banner.html',
  styleUrl: './cookie-consent-banner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'region',
    'aria-live': 'polite',
  },
})
export class CookieConsentBanner {
  public readonly acceptAll = output();
  public readonly rejectAll = output();
}
